const ICONS = {
  32: "/icons/favicon-32.png",
  64: "/icons/favicon-64.png",
  180: "/icons/apple-touch-icon.png",
};

function apply() {
  const v = Math.floor(Date.now() / 300000);
  Object.entries(ICONS).forEach(([size, src]) => {
    const rel = size === "180" ? "apple-touch-icon" : "icon";
    const selector = rel === "apple-touch-icon" ? `link[rel="apple-touch-icon"]` : `link[rel="icon"][sizes="${size}x${size}"]`;
    let el = document.head.querySelector(selector);
    if (!el) {
      el = document.createElement("link");
      el.rel = rel;
      el.type = "image/png";
      if (rel === "icon") el.sizes = `${size}x${size}`;
      document.head.appendChild(el);
    }
    el.href = `${src}?v=${v}`;
  });
}

export function initBrandIcon() {
  try {
    apply();
    document.addEventListener("visibilitychange", () => { if (!document.hidden) apply(); });
  } catch {}
}
